/**
 * Support page component - placeholder
 */

import React from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui';

export function Support() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">Help & Support</h1>
        <p className="text-gray-500 mt-2">Get help and support for your tenant management needs</p>
      </div>

      <Card>
        <CardHeader>
          <h3 className="text-lg font-medium text-gray-900">Support Center</h3>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <div className="text-6xl mb-4">🎧</div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Help & Support</h3>
            <p className="text-gray-500">Contact support or browse our help documentation.</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
